import { render, staticRenderFns } from "./UnreportedDisciplines.vue?vue&type=template&id=2a333c08&scoped=true"
import script from "./UnreportedDisciplines.vue?vue&type=script&lang=js"
export * from "./UnreportedDisciplines.vue?vue&type=script&lang=js"
import style0 from "./UnreportedDisciplines.vue?vue&type=style&index=0&id=2a333c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a333c08",
  null
  
)

export default component.exports